// extracted by mini-css-extract-plugin
export default {"paymentMethodContainer":"PaymentMethod_paymentMethodContainer__xK6Px"};